import { SliderProperty as SliderProp } from '../../peregrineFlowInterfaces';
import { Slider, Box, Typography, Tooltip } from '@mui/material';
import { HelpOutline } from '@mui/icons-material';
import { NodePropertyProp } from '../NodePropertyPane';
import { useCallback, useEffect, useState } from 'react';

function SliderProperty({ property, onChange }: NodePropertyProp) {
    const p = property as unknown as SliderProp;
    const [value, setValue] = useState<number>(p.value);

    useEffect(() => {
        setValue(p.value)
    }, [p])

    const onValueChange = useCallback((_: Event, value: number | number[]) => {
        p.value = value as number;
        onChange?.(p);
        setValue(p.value);
    }, [p, onChange]);

    return (
        <Box sx={{ width: '100%' }}>
            <Box display="flex" alignItems="center">
                <Typography variant="caption">{p.label}</Typography>
                {p.description && (
                    <Tooltip title={<div style={{ whiteSpace: 'pre-line' }}>{p.description}</div>} componentsProps={{ tooltip: { sx: { maxWidth: 'none' } } }}>
                        <HelpOutline fontSize="small" sx={{ ml: 1, color: 'text.secondary', cursor: 'help', width: 16, height: 16 }} />
                    </Tooltip>
                )}
            </Box>
            <Slider
                value={value}
                step={p.step ? p.step : 1}
                min={p.min} max={p.max}
                onChange={onValueChange}
                valueLabelDisplay="auto"
                style={{ zIndex: 2 }}
            />
        </Box>
    )
}

export default SliderProperty;
